module.exports = __webpack_public_path__ + "img/pr-3.80bed0d2.png";